import React, { Component } from 'react';
import Progress from '../../../components/layout/util/progress'
import { Link } from "react-router-dom";

class SubjectCards extends Component
{
	constructor ( props )
	{
		super( props );
		this.props = props;
	}

	renderItems = () =>
	{
		return this.props.cards.map( ( item, key ) => (
			<div key={key} className="col-12 course-subject-cards">
				<div className="course-subject-card row">
					<div className="col-5 m-0 course-subject-card-decription">
						<Link to={{
							pathname : `/course/detail/${item.id}`
						}}>
							<p className="course-subject-title">
								{item.title}
							</p>
						</Link>
					</div>
					<div className="col-7 m-0 row align-self-center start-subject-card-button">
						<div className="d-flex mr-auto order-lg-1 order-sm-2 order-md-2 order-2">
							<p className="course-subject-part">
								{item.items_count}  جلسه
							</p>
							<p className="course-subject-watch">
								{Math.ceil( item.items_time / 3600 )} ساعت
							</p>
						</div>
						<Link to={{
							pathname : `/course/detail/${item.id}`
						}} className="start-subject order-lg-2 order-sm-1 order-md-1 order-1">
							شروع
						</Link>
					</div>
					<div className="progress-bar-back col-12 p-0">
						<Progress width={100} type={1}/>
					</div>
				</div>
			</div>
		) );
	};

	render ()
	{
		return (
			<div className="course-subjects-div">
				{this.renderItems()}
			</div>
		);
	}
}

export default SubjectCards;
